module.exports = __webpack_public_path__ + "static/media/lightning_white.f4612b09.svg";